import React from 'react';

import styled from 'styled-components';

import { TotemPopup } from 'components/TotemPopup';
import { TotemPrimaryLoadingButton } from 'components/TotemPrimaryLoadingButton';

import { thermometersUpdatedOrCreatedHandler } from '../cacheHandlers/thermometersCacheHandler';

import { useCreateThermometerMutation, TotadminPermission } from 'data/__generated__';

export function CreateThermometerPopup({
    isOpen,
    setIsOpen,
    nextThermometerNumber,
}: {
    isOpen: boolean;
    setIsOpen: (arg: boolean) => void;
    nextThermometerNumber: number;
}) {
    const [createThermometer, { loading: creationLoading }] = useCreateThermometerMutation({
        variables: { number: nextThermometerNumber },
    });

    async function handleSubmit() {
        const { data } = await createThermometer();

        if (!data) {
            throw new Error('Une erreur est survenue lors de la mise à jour du thermomètre');
        }

        const { createThermometer: newThermometer } = data;

        thermometersUpdatedOrCreatedHandler([newThermometer]);

        setIsOpen(false);
    }

    return (
        <TotemPopup title="Ajouter un thermomètre" isOpen={isOpen} setIsOpen={setIsOpen} contentOverflow="visible">
            Voulez-vous ajouter le thermomètre numéro {nextThermometerNumber}
            <SubmitContainer>
                <ValidationButton
                    onClick={handleSubmit}
                    loading={creationLoading}
                    useIcon={false}
                    label="Confirmer"
                    requiredPermissions={[TotadminPermission.ThermometersManage]}
                />
            </SubmitContainer>
        </TotemPopup>
    );
}

const SubmitContainer = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 15px;
`;

const ValidationButton = styled(TotemPrimaryLoadingButton)`
    margin-top: 15px;
`;
